// same slider as insight_highlight -- see docs/modules/team.md#slider
import Swiper from 'swiper';
import { A11y, Keyboard, Mousewheel } from 'swiper/modules';

(function () {
    const sliders = [...document.querySelectorAll('[data-jb-team-slider]')];
    if (!sliders.length) return;

    sliders.forEach((slider) => {
        new Swiper(slider, {
            modules: [A11y, Keyboard, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 0,
            grabCursor: true,

            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            mousewheel: {
                forceToAxis: true,
            },

            a11y: {
                enabled: true,
                containerMessage: 'Team members',
            },
        });
    });
})();
